import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/Homepage.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/Air Curtains.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/Air flow units.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/Bio Safety.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/ceiling-suspended-laminar-flow.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/Laminar Airflow 2.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/operation Theatre laminar airflow.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/change/Pressure module.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id1/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id1/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id1/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id1/img (4).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id10/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id10/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id11/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id11/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id13/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id13/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id13/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id2/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id2/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id3/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id3/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id3/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id3/img (4).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id4/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id4/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id4/img (4).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id5/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id5/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id6/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id6/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id6/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id7/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id7/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id8/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id8/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id8/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id9/img (1).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id9/img (2).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id9/img (3).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/id9/img (4).webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img10-1.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img11.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img12.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img13.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img2.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img5.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img6.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img7.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img8.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/porductimg/img9.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ProductInfoSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
